export const ROUTE_CHANGED = 'ROUTE_CHANGED';
export const routeChanged = payload => ({
    type: ROUTE_CHANGED,
    payload,
});
